import React from 'react';
import { Dial } from '@vf-dcl/dcl-components';
import Vodafonetree from './Vodafonetree';
import '../css/Summarypage.css';
import { SummaryPageProps } from '../Types/SummarypageTypes';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import options from '../../../../../helpers/ContentFulOptions';
import { Tab, NavigationalTabs } from '@vfuk/core-navigational-tabs';
import Block from '@vfuk/core-block';
import SimpleGrid from '@vfuk/core-simple-grid';
import fireButtonAndLinkClicksEvent from '../../../../../helpers/fireButtonAndLinkClicksEvent';

const Summarypage = ({
  content,
  businessName,
  finalscore,
  tree,
  recommendation,
}: SummaryPageProps) => {
  const disclaimerText =
    content?.disclaimer?.raw &&
    documentToReactComponents(JSON.parse(content?.disclaimer?.raw), options);

  return (
    <div>
      <div data-testid="assessmentSummary" className="summaryAssessmentDiv">
        <div className="spring">
          {/* DCL Component Dial with Static content from Contentful */}
          <SimpleGrid columns={{ lg: 3, sm: 1, md: 1 }} spacing={1}>
            <div className="dispFlexStyle">
              <div className="flexColumn">
                <div className="flexRow">
                  <div className="tickDiv">
                    <img src={content.summaryPageIcons.tickIcon.file.url} />
                  </div>
                  <div className="flexColumn">
                    <div className="congHead">{content.congratsHeading}</div>
                    <div className="congText">{content.congratsText}</div>
                  </div>
                </div>
                <div className="result-txt-postn">
                  <div className="resText">{content.resultsText}</div>
                </div>

                <div className="companyName-postn">
                  <div className="companyName">{`"${businessName}"`}</div>
                </div>
              </div>
            </div>
            <div className="div-order">
              <div className="dialCenter">
                <div className="circle">
                  <Dial value={parseInt(finalscore)} maxValue={100}>
                    <Dial.Value
                      value={
                        finalscore !== '0' ? parseInt(finalscore) + '%' : '-%'
                      }
                      subLabel={content.finalScoreText}
                    />
                  </Dial>
                </div>
              </div>
            </div>
            <div className="data-interpret-order">
              <div className="main-data-div">
                <div className="congHead1">{content.interpretHead}</div>
                <div className="congText1">
                  {content.interpretText.interpretText}
                </div>
                <div className="data-interpret-main">
                  <div className="data-interpret-sub">
                    <div className="data-legent-1">
                      <img
                        className="data-interpret-img"
                        src={content.summaryPageIcons.answersIcon.file.url}
                      ></img>
                      <span className="data-interpret">
                        {content.legendText1}
                      </span>
                    </div>
                    <div className="data-legent-2">
                      <img
                        className="data-interpret-img"
                        src={content.summaryPageIcons.notAnsweredIcon.file.url}
                      ></img>
                      <span className="data-interpret interpret-data-summary-inactive-title">
                        {content.legendText2}
                      </span>
                    </div>
                  </div>
                  <div className="data-interpret-sub">
                    <div className="data-legent-3">
                      <img
                        className="data-interpret-img"
                        src={content.summaryPageIcons.strengthIcon.file.url}
                      ></img>
                      <span className="data-interpret">
                        {content.legendText3}
                      </span>
                    </div>
                    <div className="data-legent-4">
                      <img
                        className="data-interpret-img"
                        src={content.summaryPageIcons.improvementIcon.file.url}
                      ></img>
                      <span className="data-interpret interpret-data-summary-inactive-title">
                        {content.legendText4}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SimpleGrid>
        </div>
      </div>
      {/* V-Hub Recommendations */}
      {/* Vodafone Tree */}
      <div className="vodafonetreeWrapper">
        <Vodafonetree
          tree={tree}
          contentfuldata={content}
          recommendation={recommendation}
        />
      </div>

      {/* V-Hub Recommendations heading , subheading and tabs */}
      <div className="recomParent">
        <div className="recombg">
          <div className="recomTabs" id="viewrecommendation">
            {recommendation && recommendation.length > 0 && (
              <div className="recom-white-bg">
                <div className="recom-bg-color">
                  <div className="boldQuestionRecom">
                    {content.recommendationHeader}
                  </div>
                  <div className="subHeadingRecom">
                    {content.recommendationDesp}
                  </div>
                </div>
                <Block appearance="alt2">
                  <NavigationalTabs
                    width="full"
                    onTabClick={(tabName: string) => {
                      fireButtonAndLinkClicksEvent({
                        event_action: 'link click',
                        event_label: tabName,
                      });
                    }}
                  >
                    {recommendation.map((item: any, index: any) => (
                      <Tab
                        id={item.title}
                        key={index}
                        text={
                          `${tree.entities[index].maturitypercent}%` +
                          ' ' +
                          item.title
                        }
                      >
                        <Block appearance="alt2" id={item.title}>
                          {item.hasOwnProperty('text') ? (
                            <div className="smallTxtChild">{item.text}</div>
                          ) : (
                            ''
                          )}
                          {item.hasOwnProperty('relatedRecommendationItem') ? (
                            item.relatedRecommendationItem.map(
                              (recomm: any, num: any) => (
                                <div key={num}>
                                  <div className="boldQuestionChild2">
                                    {recomm.recommendationItem.title}
                                  </div>
                                  <div className="smallTxtChild">
                                    {recomm.recommendationItem.text}
                                  </div>
                                </div>
                              )
                            )
                          ) : (
                            <div className="norecomm"></div>
                          )}
                        </Block>
                      </Tab>
                    ))}
                  </NavigationalTabs>
                </Block>
              </div>
            )}
            {disclaimerText && (
              <div className="vodafonetreeWrapper">
                <p className="recommendation-disclaimer-text">
                  {disclaimerText}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summarypage;
